<template>
  <div class="modal fade exercise-modal" tabindex="-1" v-bind:id="ModalName" :aria-labelledby="ModalName + '-title'" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-heading">
            <span class="modal-eyebrow">EGZERSİZ <span v-if="Sequence">/ ÜNİTE {{ Sequence }}</span></span>
            <h1 :id="ModalName + '-title'" class="modal-title">{{ Title }}</h1>
          </div>
          <button type="button" class="btn-close" aria-label="Kapat" @click="CloseModal()"></button>
        </div>
        <div class="modal-body">
          <div v-if="IsAudio || IsTranslate" class="practice-tools">
            <section v-if="IsAudio" class="audio-panel" :aria-labelledby="ModalName + '-audio-title'">
              <div class="tool-heading"><span class="tool-icon"><i class="bi bi-headphones" aria-hidden="true"></i></span><div><h2 :id="ModalName + '-audio-title'">Dinleme pratiği</h2><p>Dinle, duraklat ve kendi hızında tekrar et.</p></div></div>
              <audio ref="audioPlayer" controls controlsList="nodownload" preload="none" :src="Audio" :aria-label="Title + ' ses kaydı'"></audio>
            </section>
            <a v-if="IsTranslate" :href="TranslateLink()" class="translate-link" target="_blank" rel="noopener noreferrer"><i class="bi bi-translate" aria-hidden="true"></i><span>Google Translate<span class="link-caption">Yeni sekmede aç</span></span><i class="bi bi-box-arrow-up-right" aria-hidden="true"></i></a>
          </div>
          <section v-if="IsImage" class="reading-panel" :aria-labelledby="ModalName + '-reading-title'">
            <div class="reading-heading"><h2 :id="ModalName + '-reading-title'">Egzersiz içeriği</h2><a :href="Image" target="_blank" rel="noopener noreferrer">Görseli büyüt<i class="bi bi-box-arrow-up-right" aria-hidden="true"></i><span class="visually-hidden"> (yeni sekmede)</span></a></div>
            <a class="exercise-image" :href="Image" target="_blank" rel="noopener noreferrer" :aria-label="Title + ' görselini yeni sekmede aç'"><img :src="Image" :alt="Title" /></a>
          </section>
        </div>
        <div class="modal-footer">
          <span class="practice-note"><i class="bi bi-journal-check" aria-hidden="true"></i>Kendi hızında öğren.</span>
          <button type="button" class="close-button" @click="CloseModal()">Kapat</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import bootstrapBundle from 'bootstrap/dist/js/bootstrap.bundle';
  import { manageModalFocus } from '@/common/modal-focus';
  export default {
    name: "ExcerciseModal",
    props: {
      ModalName:{
        type:String,
        default:'ModalExcercise'
      },
      Visible:{
        type:Boolean,
        default:false
      },
      Category:{
        type:Number,
        default: 0
      },
      Sequence:{
        type:Number,
        default: 0
      },
      Title:{
        type:String,
        default: null
      },
      Content:{
        type:String,
        default: null
      },
      IsImage:{
        type:Boolean,
        default: false
      },
      IsAudio:{
        type:Boolean,
        default: false
      },
      IsTranslate:{
        type:Boolean,
        default: false
      }
    },
    data() {
      return {
        modalElement:null,
        cleanupModalFocus:null
      };
    },
    computed: {
      Image(){
          let result ='';
          if(this.Category!=0 && this.Sequence!=0){
            result=process.env.VUE_APP_ROOT_API+ 'Source/exercise/image/?category=' + this.Category + '&number=' + this.Sequence;
          }
          return result;
      },
      Audio(){
          let result ='';
          if(this.Category!=0 && this.Sequence!=0){
            result=process.env.VUE_APP_ROOT_API+ 'Source/exercise/audio/?category=' + this.Category + '&number=' + this.Sequence;
          }
          return result;
      },
    },
    methods: {
      TranslateLink() {
          const GOOGLE_TRANSLATE_BASE_URL = "https://translate.google.com/?sl=en&tl=tr&text=";
          let categoriArray = [20,21,22,23,24,25,26,27,28,29,30,31,32];
          let content = this.Content || '';
          if (categoriArray.find(x=>x==parseInt(this.Category))) {
              content = content.replace(/ A:/gi, '\nA:');
              content = content.replace(/ B:/gi, '\nB:');
          }
          return GOOGLE_TRANSLATE_BASE_URL + encodeURIComponent(content);
      },
      CloseModal(){
        this.$refs.audioPlayer?.pause();
        this.modalElement.hide();
        this.$emit("CloseModal", false);
      }
    },
    watch: {
      Visible(value){
        if(value){
          this.modalElement.show();
        }
      }
    },
    mounted: function() {
      const element = document.getElementById(this.ModalName);
      this.cleanupModalFocus = manageModalFocus(element);
      this.modalElement = new bootstrapBundle.Modal(element,{backdrop: 'static',keyboard: false});
    },
    beforeUnmount() {
      this.cleanupModalFocus?.();
      this.modalElement?.dispose();
    }
  };
  </script>
  
  <style scoped>
  .exercise-modal { color: #24382e; }
  .modal-content { border: 1px solid #e4eae4; border-radius: 22px; overflow: hidden; box-shadow: 0 24px 80px #142c2526; }
  .modal-header { align-items: flex-start; gap: 20px; padding: 26px 28px; background: #fff; border-bottom: 1px solid #e8eee7; }
  .modal-heading { min-width: 0; }
  .modal-eyebrow { display: block; margin-bottom: 10px; color: var(--brand-link); font-size: .7rem; font-weight: 700; letter-spacing: .12em; }
  .modal-title { font-size: clamp(1.15rem, 3vw, 1.5rem); font-weight: 700; line-height: 1.4; letter-spacing: -.025em; overflow-wrap: anywhere; }
  .modal-header .btn-close { flex-shrink: 0; margin: -6px -8px 0 0; padding: 14px; background-size: 12px; border-radius: 50%; }
  .modal-body { padding: 24px 28px; background: #f7f9f7; }
  .practice-tools { display: flex; align-items: center; flex-wrap: wrap; gap: 16px; margin-bottom: 24px; }
  .practice-tools:last-child { margin-bottom: 0; }
  .audio-panel { flex: 1 1 320px; min-width: 0; padding: 18px; background: #fff; border: 1px solid #e4eae4; border-radius: 14px; }
  .tool-heading { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; }
  .tool-icon { display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; flex-shrink: 0; color: var(--brand-link); background: #edf5eb; border-radius: 12px; font-size: 1.2rem; }
  .tool-heading h2, .reading-heading h2 { font-size: .9rem; font-weight: 600; margin: 0; }
  .tool-heading p { margin: 5px 0 0; color: #637269; font-size: .76rem; line-height: 1.6; }
  audio { display: block; width: 100%; height: 42px; }
  .translate-link { display: inline-flex; align-items: center; gap: 12px; padding: 14px 16px; min-height: 44px; border: 1px solid #dce5dd; border-radius: 12px; background: #fff; color: var(--brand-link); text-decoration: none; font-size: .82rem; font-weight: 600; }
  .translate-link > i:first-child { font-size: 1.2rem; }
  .translate-link > i:last-child { font-size: .75rem; margin-left: auto; }
  .link-caption { display: block; margin-top: 4px; color: #637269; font-size: .7rem; font-weight: 400; }
  .translate-link:hover { background: #edf5eb; border-color: #aac5ab; }
  .reading-panel { border: 1px solid #e4eae4; border-radius: 14px; overflow: hidden; background: #fff; }
  .reading-heading { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; padding: 18px; border-bottom: 1px solid #edf0ed; }
  .reading-heading a { display: inline-flex; align-items: center; gap: 8px; color: var(--brand-link); font-size: .75rem; text-underline-offset: 3px; }
  .exercise-image { display: block; padding: 12px; text-align: center; }
  .exercise-image img { max-width: 100%; height: auto; }
  .modal-footer { justify-content: space-between; gap: 12px; padding: 16px 28px; background: #fff; border-top: 1px solid #e8eee7; }
  .practice-note { display: inline-flex; align-items: center; gap: 8px; margin: 0; color: #637269; font-size: .78rem; }
  .close-button { min-height: 44px; margin: 0; padding: 10px 24px; border: 0; border-radius: 10px; background: var(--brand-link); color: #fff; font-size: .85rem; font-weight: 600; }
  .close-button:hover { background: var(--brand-primary-hover); }
  .exercise-modal :is(button, a, audio):focus-visible { outline: 3px solid var(--brand-link); outline-offset: 3px; }
  .exercise-image:focus-visible { outline-offset: -4px; }
  @media (max-width: 575.98px) {
    .modal-dialog { margin: 12px; }
    .modal-content { border-radius: 18px; }
    .modal-header { padding: 22px 18px; }
    .modal-body { padding: 18px; }
    .modal-footer { padding: 14px 18px; }
    .practice-tools { gap: 12px; margin-bottom: 18px; }
    .translate-link { width: 100%; }
    .audio-panel, .reading-heading { padding: 14px; }
    .exercise-image { padding: 6px; }
  }
  </style>
